import { Button } from "@sellar-io/components";
import { Icon } from "../../../components";
import { IntegrationCard } from "./IntegrationCard";

export const IntegrationPartner = ({
  appImage,
  appName,
  description,
  guideUrl,
  buttonUrl,
  isIntegrationActive,
  disconnectIntegration,
}: {
  appImage: string;
  appName: string;
  description: string;
  guideUrl?: string;
  buttonUrl?: string;
  isIntegrationActive?: boolean;
  disconnectIntegration?: () => void;
}) => {
  return (
    <IntegrationCard
      appImage={appImage}
      title={appName}
      description={description}
      headerAction={
        buttonUrl && isIntegrationActive ? (
          <Button
            size={"small"}
            color={"red"}
            onClick={() => disconnectIntegration?.()}
          >
            Disconnect
          </Button>
        ) : undefined
      }
      actions={
        <>
          {guideUrl && (
            <Button
              color={"secondary"}
              onClick={() => window.open(guideUrl, "_blank")}
            >
              <Icon icon={"OPEN_IN_NEW"} />
              VIEW SETUP GUIDE
            </Button>
          )}
          {buttonUrl && !isIntegrationActive && (
            <Button
              size={"small"}
              color={"secondary"}
              onClick={() => window.open(buttonUrl, "_blank")}
            >
              Connect
            </Button>
          )}
        </>
      }
    />
  );
};
